import { Task } from "../models/task.model";
import { responseHero } from "../utils/axiosInterceptor";

// Lekérés (opcionális státusz szűréssel)
export const getTasks = (status?: 'TODO' | 'IN_PROGRESS' | 'DONE'): Promise<Task[]> => {
    const url = status 
        ? `${process.env.REACT_APP_API_URL}/tasks?status=${status}` 
        : `${process.env.REACT_APP_API_URL}/tasks`;

    return new Promise<Task[]>((resolve, reject) => {
        responseHero.get(url)
        .then((response) => {
            resolve(response.data as Task[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

// Törlés
export const removeTask = (id: string): Promise<{ message: string; task: Task }> => {
    return new Promise((resolve, reject) => {
        responseHero.delete(`${process.env.REACT_APP_API_URL}/tasks/${id}`)
        .then((response) => {
            resolve(response.data);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};

//
export const updateTaskStatus = (id: string, taskState: 'TODO' | 'IN_PROGRESS' | 'DONE'): Promise<Task> => {
    return new Promise((resolve, reject) => {
        responseHero.patch(`${process.env.REACT_APP_API_URL}/tasks/${id}/status`, { taskState })
        .then((response) => {
            resolve(response.data as Task);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};